// import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  DeleteOutlined,
  ExclamationCircleFilled,
  PlusOutlined,
  MinusOutlined
} from '@ant-design/icons';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { BENEFICIADOS } from 'constants/nombresCatalogos';
import { groupObjectsByProperty } from 'utils/groupObjectsByProperty';
import { removeDuplicatesByProperty } from 'utils/removeDuplicatedByProperty';
import './RepresentantesSujetosObligados.scss';
import { validateFileList } from 'utils/form/validators';
import { Row, Col, Form, Divider, Button, Tag, Select, Input, Tooltip } from 'antd';
import { AddButton, Upload } from 'components';
import { useSelector } from 'react-redux';
import * as fieldMsgs from 'constants/formFieldsMessages';
// import {
//   CAMPANIA_ASO,
//   PRECAMPANIA_ASO,
//   APOYO_CIUDADANO_ASO,
//   INTERCAMPANIA_ASO
// } from 'constants/tipoAsociaciones';

const getBeneficiadosPorAsociacionId = (listaAsociaciones, beneficiadoId) => {
  const asociacion = listaAsociaciones?.find((b) => b.idTipoAsociacion === beneficiadoId);
  return asociacion?.beneficiarios || [];
};

const getTiposAsociacionPorProcesoEspecifico = (listaBeneficiadosCompleta, procesoEspecificoId) => {
  // const listaBeneficiados = listaBeneficiadosCompleta.filter(
  //   (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
  // );
  let listaBeneficiados = [];
  if (procesoEspecificoId === 4) {
    listaBeneficiados = listaBeneficiadosCompleta;
  } else {
    listaBeneficiados = listaBeneficiadosCompleta.filter(
      (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
    );
  }
  let asociaciones = groupObjectsByProperty(listaBeneficiados, 'tipoAsociacion');

  asociaciones = Object.keys(asociaciones).reduce((acc, key) => {
    if (key !== 'CANDIDATURA INDEPENDIENTE' && key !== 'PRECANDIDATO') {
      acc[key] = asociaciones[key];
    }
    return acc;
  }, {});

  return Object.keys(asociaciones).map((tipoAsociacion) => {
    return {
      tipoAsociacion,
      idTipoAsociacion: asociaciones[tipoAsociacion][0].idTipoAsociacion,
      beneficiarios: asociaciones[tipoAsociacion]
    };
  });
};

const validateAtribute = (objeto, atributo) => {
  // Verificar si el objeto es nulo o indefinido
  if (objeto === null || objeto === undefined || typeof objeto !== 'object') {
    return false;
  }
  // Verificar si el atributo existe en el objeto
  // eslint-disable-next-line no-prototype-builtins
  return objeto.hasOwnProperty(atributo);
};

const RepresentantesSujetosObligados = ({ form, loadingImages }) => {
  const listaBeneficiados = useSelector(selectCatalogByName(BENEFICIADOS));

  const setNameSujetoObligadoToForm = (_, dataSO, idx) => {
    const dataSujetosObligados = form.getFieldsValue().sujetosObligados;
    if (dataSujetosObligados.length !== 0) {
      dataSujetosObligados[idx].suejetoObligado = dataSO.sujetoObligado;
      form.setFieldsValue({
        sujetosObligados: [...dataSujetosObligados]
      });
    }
  };

  const addSujetoObligadoManual = (idx, indSO) => {
    const { sujetosObligados } = form.getFieldsValue('sujetoObligado');
    const updatedSujetoObligado = {
      ...sujetosObligados[idx],
      sujetoObligadoId: indSO,
      sujetoObligado: undefined
    };
    const updatedSujetosObligadosList = [...sujetosObligados];
    updatedSujetosObligadosList[idx] = updatedSujetoObligado;
    form.setFieldsValue({
      sujetosObligados: updatedSujetosObligadosList
    });
  };

  const renderHeader = () => (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} className="col-dos-instrucciones">
          <span className="instruction-span-purple" style={{ paddingLeft: '9px' }}>
            Agrega los registros necesarios.
          </span>
          <Tag
            className="instruction-span-pink"
            icon={<ExclamationCircleFilled style={{ fontSize: '10px' }} />}
            bordered={false}
            color="magenta"
            style={{ marginBottom: '6px', paddingLeft: '9px' }}>
            El registro de representantes de sujetos obligados es opcional. Si realizas el registro
            completa todos todos los campos solicitados.
          </Tag>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={14} className="representantesSO-header-tabla">
          <span>*</span>Información del Sujeto Obligado:
        </Col>
        <Col xs={3} style={{ textAlign: 'center' }} className="representantesSO-header-tabla">
          <span>*</span>Identificación anverso:
        </Col>
        <Col xs={3} style={{ textAlign: 'center' }} className="representantesSO-header-tabla">
          <span>*</span>Identificación reverso:
        </Col>
        <Col xs={2} style={{ textAlign: 'center' }} className="representantesSO-header-tabla">
          <span>*</span>Firma digital:
        </Col>
        <Col xs={2} style={{ textAlign: 'center' }} className="representantesSO-header-tabla">
          <span>*</span>Acciones:
        </Col>
      </Row>
    </>
  );

  const renderInput = (field, index, remove) => {
    return (
      <div key={field.key}>
        <h3>Registro {index + 1}</h3>
        <div className="container-representantesSO">
          <div className="container-info-representantesSO">
            <div className="info-representanteSujetoObligado">
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) => {
                  return prevValues.procesoEspecificoId !== curValues.procesoEspecificoId;
                }}>
                {() => {
                  const { procesoEspecificoId } = form.getFieldsValue('procesoEspecificoId');
                  let tipoAsociaciones = [];
                  if (procesoEspecificoId !== undefined) {
                    tipoAsociaciones = getTiposAsociacionPorProcesoEspecifico(
                      listaBeneficiados,
                      procesoEspecificoId
                    );
                  }
                  return (
                    <Form.Item
                      name={[field.name, 'tipoAsociacionId']}
                      label="Tipo de asociación:"
                      Key={[field.fieldKey, 'tipoAsociacionId']}
                      rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                      <Select
                        style={{
                          width: 230
                        }}
                        placeholder="Selecciona"
                        options={tipoAsociaciones}
                        fieldNames={{
                          value: 'idTipoAsociacion',
                          label: 'tipoAsociacion'
                        }}
                        filterOption={(inputValue, option) =>
                          option.nombreProcesoEspecifico
                            ?.toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                        }
                        showSearch
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, curValues) => {
                  if (prevValues.sujetosObligados?.length !== curValues.sujetosObligados?.length) {
                    return true; // Se debe actualizar si las longitudes son diferentes
                  }

                  // Iterar sobre cada objeto en el array
                  for (let i = 0; i < prevValues.sujetosObligados?.length; i += 1) {
                    // Verificar si hay algún cambio en el tipoAsociacionId
                    if (
                      prevValues.sujetosObligados[i]?.tipoAsociacionId !==
                      curValues.sujetosObligados[i]?.tipoAsociacionId
                    ) {
                      return true; // Se debe actualizar si hay un cambio
                    }
                  }

                  return false; // No se necesita actualizar si no hay cambios
                }}>
                {() => {
                  const values = form.getFieldsValue().sujetosObligados;
                  const sujetoObligadoArray =
                    form.getFieldsValue('sujetoObligado').sujetosObligados;
                  const { procesoEspecificoId } = form.getFieldsValue('procesoEspecificoId');
                  const { estadoId } = form.getFieldsValue('estadoId');
                  const tiposAsociacionPorProcesoEspecifico =
                    getTiposAsociacionPorProcesoEspecifico(listaBeneficiados, procesoEspecificoId);
                  let sujetosObligadosList = [];
                  if (validateAtribute(values[index], 'tipoAsociacionId')) {
                    const { tipoAsociacionId } = values[index];
                    if (tipoAsociacionId !== 0) {
                      const beneficiadosPorAsociacion = getBeneficiadosPorAsociacionId(
                        tiposAsociacionPorProcesoEspecifico,
                        tipoAsociacionId
                      );
                      const beneficiadosPorEntidad = beneficiadosPorAsociacion?.filter(
                        (beneficiado) => beneficiado.idEstado === estadoId
                      );
                      // console.log('beneficiadosPorEntidad', beneficiadosPorEntidad);
                      sujetosObligadosList = removeDuplicatesByProperty(
                        beneficiadosPorEntidad.map((beneficiado) => ({
                          sujetoObligado: beneficiado.sujetoObligado,
                          idSujetoObligado: beneficiado.idSujetoObligado
                        })),
                        'idSujetoObligado'
                      );
                    }
                  }
                  return (
                    <>
                      {sujetoObligadoArray[index]?.sujetoObligadoId > 0 ||
                      sujetoObligadoArray[index]?.sujetoObligadoId === undefined ? (
                        <Row>
                          <Form.Item
                            name={[field.name, 'sujetoObligadoId']}
                            label="Sujeto Obligado:"
                            Key={[field.fieldKey, 'sujetoObligadoId']}
                            rules={[
                              {
                                required: sujetoObligadoArray[index]?.sujetoObligadoId !== 0,
                                message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                              }
                            ]}>
                            <Select
                              style={{
                                width: 200,
                                paddingRight: '5px'
                              }}
                              options={sujetosObligadosList}
                              placeholder="Selecciona"
                              fieldNames={{
                                value: 'idSujetoObligado',
                                label: 'sujetoObligado'
                              }}
                              filterOption={(inputValue, option) =>
                                option.sujetoObligado
                                  ?.toUpperCase()
                                  .indexOf(inputValue.toUpperCase()) !== -1
                              }
                              onChange={(value, label) =>
                                setNameSujetoObligadoToForm(value, label, index)
                              }
                              showSearch
                            />
                          </Form.Item>
                          <Tooltip title="Agregar sujeto obligado" placement="topLeft">
                            <Button
                              className="add-servidorPublicoManual"
                              shape="square"
                              size="small"
                              icon={<PlusOutlined style={{ color: '#d5007f' }} />}
                              onClick={() => {
                                addSujetoObligadoManual(index, 0);
                              }}
                              style={{ marginTop: '35px', borderColor: '#d5007f' }}
                              disabled={sujetoObligadoArray[index]?.sujetoObligadoId === 0}
                            />
                          </Tooltip>
                        </Row>
                      ) : (
                        <Row>
                          <Form.Item
                            name={[field.name, 'sujetoObligado']}
                            label="Nombre, Partido o Coalición:"
                            Key={[field.fieldKey, 'sujetoObligado']}
                            rules={[
                              { required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }
                            ]}>
                            <Input className="input-so" placeholder="Escribe" maxLength={50} />
                          </Form.Item>
                          <Tooltip title="Seleccionar sujeto obligado" placement="topLeft">
                            <Button
                              className="add-servidorPublicoManual"
                              shape="square"
                              size="small"
                              icon={<MinusOutlined style={{ color: '#d5007f' }} />}
                              onClick={() => {
                                addSujetoObligadoManual(index, undefined);
                              }}
                              style={{ marginTop: '35px', borderColor: '#d5007f' }}
                            />
                          </Tooltip>
                        </Row>
                      )}
                      <Form.Item
                        name={[field.name, 'acreditacion']}
                        label="Escrito de acreditación:"
                        Key={[field.fieldKey, 'acreditacion']}
                        rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                        <Input
                          style={{
                            width: 230
                          }}
                          maxLength={50}
                          placeholder="Escribe"
                        />
                      </Form.Item>
                    </>
                  );
                }}
              </Form.Item>
            </div>
            <div className="info-representanteSujetoObligado">
              <Form.Item
                name={[field.name, 'primerApellido']}
                label="Primer apellido:"
                Key={[field.fieldKey, 'primerApellido']}
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input
                  style={{
                    width: 230
                  }}
                  maxLength={50}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                name={[field.name, 'segundoApellido']}
                label="Segundo apellido:"
                Key={[field.fieldKey, 'segundoApellido']}>
                <Input
                  style={{
                    width: 230
                  }}
                  maxLength={50}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                name={[field.name, 'nombre']}
                label="Nombre (s):"
                Key={[field.fieldKey, 'nombre']}
                rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                <Input
                  style={{
                    width: 230
                  }}
                  maxLength={50}
                  placeholder="Escribe"
                />
              </Form.Item>
            </div>
            <div className="info-representanteSujetoObligado">
              <Form.Item
                name={[field.name, 'puesto']}
                label="Puesto:"
                Key={[field.fieldKey, 'puesto']}>
                <Input
                  style={{
                    width: 230
                  }}
                  maxLength={200}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                name={[field.name, 'claveElector']}
                label="Clave de elector:"
                Key={[field.fieldKey, 'claveElector']}
                rules={[
                  {
                    required: true,
                    message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                  },
                  {
                    pattern: '^([A-Za-z]{5,6}\\d{8}[H|M|X]\\d{3})$|^([0-9]{13})$',
                    message: 'Verifica el formato de la clave de elector'
                  }
                ]}>
                <Input
                  style={{
                    width: 230
                  }}
                  maxLength={18}
                  placeholder="Escribe"
                />
              </Form.Item>
              <Form.Item
                name={[field.name, 'correoElectronico']}
                label="Correo electrónico:"
                Key={[field.fieldKey, 'correoElectronico']}
                rules={[{ type: 'email', message: fieldMsgs.ERR_EMAIL_FIELD_FORMAT }]}>
                <Input
                  style={{
                    width: 230
                  }}
                  maxLength={50}
                  placeholder="Escribe"
                />
              </Form.Item>
            </div>
          </div>
          <div className="container-imgs-representantesSO">
            <Form.Item
              name={[field.name, 'identAnverso']}
              Key={[field.fieldKey, 'identAnverso']}
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaInicioIdentAnversoSO"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <Form.Item
              name={[field.name, 'identReverso']}
              Key={[field.fieldKey, 'identReverso']}
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaInicioIdentReversoSO"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
            <Form.Item
              name={[field.name, 'firma']}
              Key={[field.fieldKey, 'firma']}
              rules={[
                {
                  validator: validateFileList
                }
              ]}>
              <Upload
                className="actaInicioFirmaSO"
                key={index}
                loading={loadingImages}
                aceptaVideo={false}
              />
            </Form.Item>
          </div>
          <div className="servidoresublicosJL-imagenes-acciones">
            <Button style={{ height: '2em' }}>
              <DeleteOutlined onClick={() => remove(index)} />
            </Button>
          </div>
        </div>
        <Divider />
      </div>
    );
  };

  return (
    <div className="formulario-representantesSujetosObligados-acta-cierre">
      <Form form={form} layout="vertical">
        {renderHeader()}
        <Form.List name="sujetosObligados" initialValue={[]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => {
                return renderInput(field, index, remove);
              })}
              <div className="representantesSO-btn">
                <Form.Item>
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '2em' }}>
                    Agregar Nuevo
                  </AddButton>
                </Form.Item>
              </div>
            </>
          )}
        </Form.List>
      </Form>
    </div>
  );
};

export default RepresentantesSujetosObligados;

RepresentantesSujetosObligados.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    setFieldValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    getFieldValue: PropTypes.func
  }).isRequired,
  loadingImages: PropTypes.bool
};

RepresentantesSujetosObligados.defaultProps = {
  loadingImages: false
};
